import { apiHelper } from "./api_helper";

export const MAUTHU_KETQUA_API_END_POINT = "mauthu-ketqua";
export const MAUTHU_KETQUA_PRINT_API = "mauthu-ketqua/print-pdf";

export const mauThuKetQuaApi = {
    SelectAsync: (dm_truong_id, nam_hoc) => apiHelper.get(`${MAUTHU_KETQUA_API_END_POINT}/truong/${dm_truong_id}/nam_hoc/${nam_hoc}`),
    SelectAllAsync: (dm_coso_id, nam_hoc) => apiHelper.get(`${MAUTHU_KETQUA_API_END_POINT}/dm_coso_id/${dm_coso_id}/nam_hoc/${nam_hoc}`),
    Detail: (id) => apiHelper.get(`${MAUTHU_KETQUA_API_END_POINT}/${id}`),
    Update: (data)=> apiHelper.put(MAUTHU_KETQUA_API_END_POINT, data),
    Insert: (data)=> apiHelper.post(MAUTHU_KETQUA_API_END_POINT, data),
    print_pdf_file: (data) => apiHelper.post(`${MAUTHU_KETQUA_PRINT_API}`, data)


}